import React, {
  useEffect, useState, useRef, useCallback,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import classes from './tabs.module.scss';
import Button from '../../../../_common/Form/Buttons/Button';
import {
  addPhysicianGroupNoteRequest,
  addPhysicianNoteRequest, getPhysicianGroupNotesRequest,
  getPhysicianNotesRequest,
  getPhysicianVisitsRequest,
} from '../../../../../store/actions/physicians';
import avatar from '../../../../../assets/icons/avatar.png';
import NoteModal from '../../../../_common/Modal/NoteModal/NoteModal';
import accountHelpers from '../../../../../utils/accountHelpers';
import VisitModal from '../../../../_common/Modal/VisitModal/VisitModal';
import Loader from '../../../../_common/Loader/Loader';

const Notes = ({ type }) => {
  const { physicianId, groupName } = useParams();
  const dispatch = useDispatch();
  const physicianVisits = useSelector((store) => store.physicians.physicianVisits);
  const physicianNotes = useSelector((store) => store.physicians.physicianNotes);
  const physiciansList = useSelector((store) => store.physicians.physiciansList);
  const physicianGroupNotes = useSelector((store) => store.physicians.physicianGroupNotes);
  const noteRef = useRef(null);

  const [requestData, setRequestData] = useState({
    visitId: '',
    physicianId,
    userId: accountHelpers.getUser().id,
    name: accountHelpers.getUser().name,
    note: '',
    userImage: accountHelpers.getUser().link,
  });
  const [selectOption, setSelectOption] = useState('');
  const [isOpenNoteModal, setIsOpenNoteModal] = useState(false);
  const [isOpenAppointmentModal, setIsOpenAppointmentModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const sortingSelect = physicianVisits
    .map((p) => ({ id: p.id, value: `${moment.utc(p.dateTime).local().format('DD.MM - LT')}${p?.Rep ? ` - ${p?.Rep}` : ''}` }));

  useEffect(() => {
    (async () => {
      if (type) {
        await Promise.all([dispatch(getPhysicianGroupNotesRequest({ group: groupName })),
          dispatch(getPhysicianVisitsRequest({ group: groupName }))]);

        setRequestData({
          name: accountHelpers.getUser().name,
          note: '',
          // userImage: accountHelpers.getUser().link,
          group: groupName,
        });
      } else {
        await Promise.all([dispatch(getPhysicianVisitsRequest({ physicianId })),
          dispatch(getPhysicianNotesRequest({ physicianId }))]);
      }

      setLoading(false);
    })();
  }, []);

  const changeTextArea = (value) => {
    setRequestData((prev) => ({ ...prev, note: value }));
  };

  const changeSelect = (option) => {
    setRequestData((prev) => ({ ...prev, visitId: option.id }));
    setSelectOption(option.value);
  };

  const onSendNoteClick = async () => {
    let data;

    if (!requestData.note) {
      toast.error('Please write note ');
      return;
    }

    if (type) {
      data = await dispatch(addPhysicianGroupNoteRequest(requestData));
    } else {
      data = await dispatch(addPhysicianNoteRequest(requestData));
    }

    if (data.status === 'ok') {
      onCloseModal();
      window.scrollTo(0, noteRef.current.offsetTop);
    }
  };

  const onCloseModal = () => {
    setRequestData((prev) => ({ ...prev, visitId: '', note: '' }));
    setSelectOption('');
    setIsOpenNoteModal(false);
  };

  const requestAfterSave = useCallback(async () => {
    const sendData = type ? { group: groupName } : { physicianId };

    await dispatch(getPhysicianVisitsRequest(sendData));
  }, []);

  const notes = type ? physicianGroupNotes : physicianNotes;

  return (
    <>
      {loading ? <Loader className={classes.loader} />
        : (
          <div className={classes.note_wrapper} ref={noteRef}>
            <div className={classes.left}>
              <div className={classes.header_left}>
                <h2>Note</h2>

                <Button
                  title="Add notes"
                  className={classes.assign_btn}
                  addButton
                  type="button"
                  reverseColor
                  onClick={() => setIsOpenNoteModal(true)}
                />
              </div>

              {notes.map((p) => (
                <div key={p.id} className={classes.notes}>
                  <div className={classes.notes_header}>
                    <div>
                      <img
                        src={p.userImage ? p.userImage : avatar}
                        alt="img"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = avatar;
                        }}
                      />

                      <p>{p.name}</p>
                    </div>

                    <span>
                      {moment.utc(p.createdAt).local().format('MM/DD/YYYY LT')}
                    </span>
                  </div>

                  <p>{p.note}</p>
                </div>
              ))}
            </div>

            <div className={classes.right}>
              <div className={classes.header_right}>
                <h2>Upcoming Appointments</h2>

                <Button
                  title="Set appointment"
                  className={classes.assign_btn}
                  addButton
                  type="button"
                  reverseColor
                  onClick={() => setIsOpenAppointmentModal(true)}
                />
              </div>

              <div className={classes.header_wrapper}>
                {physicianVisits.map((p) => (
                  <div className={classes.header_row} key={p.id}>
                    <div className={classes.header_days}>
                      <div className={classes.header_days__item}>
                        <div className={classes.header_days__text}>
                          {moment.utc(p.dateTime).local().format('MMM DD')}
                        </div>

                        <div className={classes.header_days__round}>
                          <div className={classes.header_days__round__min} />

                          <div className={classes.header_days__line} />
                        </div>
                      </div>
                    </div>

                    <div className={classes.header_visit}>
                      <div className={classes.header_title}>Upcoming Visit</div>

                      <div className={classes.header_main}>
                        <p>
                          {moment.utc(p.dateTime).local().format('MM/DD/YYYY LT')}
                        </p>

                        <p>{p.Rep}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <NoteModal
              isOpenModal={isOpenNoteModal}
              onClose={onCloseModal}
              textValue={requestData.note}
              onChangeText={changeTextArea}
              saveNote={onSendNoteClick}
              selectNote={sortingSelect}
              onChangeSelect={changeSelect}
              selectOption={selectOption}
              showSelect
              showCheckbox={false}
              group={!!type}
            />

            {isOpenAppointmentModal && (
              <VisitModal
                isOpenModal={isOpenAppointmentModal}
                physicianId={!type ? physicianId : null}
                physicianName={!type ? `${physiciansList?.[0]?.firstName} ${physiciansList?.[0]?.lastName}` : null}
                groupName={!type ? (physiciansList?.[0]?.group || '') : null}
                requestAfterSave={requestAfterSave}
                disableResetAfterRepSelect
                onClose={() => setIsOpenAppointmentModal(false)}
              />
            )}
          </div>
        )}
    </>

  );
};

Notes.propTypes = {
  type: PropTypes.string,
};

Notes.defaultProps = {
  type: '',
};

export default Notes;
